export default {
  SET_EDITOR_TITLE (state, value) {
    state.editorTitle = value
  },
  // new Data by liugezhou 
  SET_ACTIVITY_ID (state, value) {
    state.activityId = value
  },
  SET_ACTIVITY_INFO (state, value) {
    state.activityInfo = value
  },
  SET_LOGIN_TYPE (state, value) {
    state.loginType = value
  },
  SET_USER_INFO (state, value) {
    state.userInfo = value
  },
  SET_PLAYER_INFO (state, value) {
    state.playerInfo = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js